import { DeleteOutline } from "@mui/icons-material";
import {
  CircularProgress,
  Card,
  IconButton,
  Stack,
  Typography,
  Chip,
  Box,
  useTheme,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { NON_WORKING_DAY_DELETE_ID } from "../../../../../../enums/ApiPaths";
import useDelete from "../../../../../../hooks/useDelete";
import { WORKING_HOURS_TABLE } from "../../../../../../enums/QueryKeys";

export default function NonWorkingDayDeleteForm({ date }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const deleting = useDelete(
    date?.id,
    NON_WORKING_DAY_DELETE_ID,
    WORKING_HOURS_TABLE,
    "NonWorkingDayDeleteConfirmation",
    null
  );

  function handleDelete() {
    deleting.deleteFn();
  }

  return (
    <>
      <Card
        sx={{
          p: 2,
          m: 1,
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.shadows[1],
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            boxShadow: theme.shadows[2],
            borderColor: theme.palette.primary.light,
          },
          minWidth: 160,
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
        >
          <Box>
            <Chip 
              label={date?.date}
              className={"Mui-selected"}
            />
          </Box>
          
          {deleting.loading ? (
            <CircularProgress size={24} />
          ) : (
            <IconButton
              color="error"
              onClick={handleDelete}
              size="small"
              title={t("Delete")}
              sx={{
                backgroundColor: theme.palette.error.light,
                color: 'white',
                '&:hover': {
                  backgroundColor: theme.palette.error.main,
                  transform: 'scale(1.1)',
                },
                transition: 'all 0.2s ease-in-out',
              }}
            >
              <DeleteOutline fontSize="small" />
            </IconButton>
          )}
        </Stack>
      </Card>
      <deleting.ConfirmationDialog />
    </>
  );
}